import { frontendURL } from 'dashboard/helper/URLHelper.js';
import {
  QA_DASHBOARD_VIEW_PERMISSIONS,
  QA_VIEW_PERMISSIONS,
  QA_REVIEW_PERMISSIONS,
  QA_POLICY_MANAGE_PERMISSIONS,
  QA_ALERT_MANAGE_PERMISSIONS,
  QA_SENSITIVE_EVIDENCE_VIEW_PERMISSIONS,
  QA_LIVE_MONITOR_VIEW_PERMISSIONS,
  QA_AGENT_KPI_VIEW_PERMISSIONS,
  QA_APPEAL_MANAGE_PERMISSIONS,
} from 'dashboard/constants/permissions';
import QaDashboardPageRouteView from './pages/QaDashboardPageRouteView.vue';
import QaDashboardSummaryPage from './pages/QaDashboardSummaryPage.vue';
import QaTemplatePolicyAuditPage from './pages/QaTemplatePolicyAuditPage.vue';
import QaCloseTypeAuditPage from './pages/QaCloseTypeAuditPage.vue';
import QaKeywordSearchPage from './pages/QaKeywordSearchPage.vue';
import QaSafetyAuditPage from './pages/QaSafetyAuditPage.vue';
import QaAlertHubPage from './pages/QaAlertHubPage.vue';
import QaAgentKpiPage from './pages/QaAgentKpiPage.vue';
import QaMetricDetailPage from './pages/QaMetricDetailPage.vue';
import QaCustomerInsightPage from './pages/QaCustomerInsightPage.vue';
import QaCalibrationPage from './pages/QaCalibrationPage.vue';
import QaTrendsPage from './pages/QaTrendsPage.vue';
import QaAppealsPage from './pages/QaAppealsPage.vue';

// Align with QaDashboardPolicy::VIEW_PERMISSIONS — no legacy agent bypass.
const meta = {
  permissions: {
    anyOf: [
      'administrator',
      QA_DASHBOARD_VIEW_PERMISSIONS,
      QA_VIEW_PERMISSIONS,
      QA_REVIEW_PERMISSIONS,
      QA_POLICY_MANAGE_PERMISSIONS,
      QA_ALERT_MANAGE_PERMISSIONS,
      QA_SENSITIVE_EVIDENCE_VIEW_PERMISSIONS,
      QA_LIVE_MONITOR_VIEW_PERMISSIONS,
    ],
  },
};

const keywordMeta = {
  permissions: {
    anyOf: [
      'administrator',
      QA_SENSITIVE_EVIDENCE_VIEW_PERMISSIONS,
      QA_POLICY_MANAGE_PERMISSIONS,
    ],
  },
};

const agentKpiMeta = {
  permissions: {
    anyOf: ['administrator', QA_AGENT_KPI_VIEW_PERMISSIONS],
  },
};

const appealMeta = {
  permissions: {
    anyOf: ['administrator', QA_APPEAL_MANAGE_PERMISSIONS],
  },
};

const qaDashboardRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/qa-dashboard'),
      component: QaDashboardPageRouteView,
      children: [
        {
          path: '',
          name: 'qa_dashboard_home',
          meta,
          component: QaDashboardSummaryPage,
        },
        {
          path: 'template-audit',
          name: 'qa_dashboard_template_audit',
          meta,
          component: QaTemplatePolicyAuditPage,
        },
        {
          path: 'close-type-audit',
          name: 'qa_dashboard_close_type_audit',
          meta,
          component: QaCloseTypeAuditPage,
        },
        {
          path: 'keyword-search',
          name: 'qa_dashboard_keyword_search',
          meta: keywordMeta,
          component: QaKeywordSearchPage,
        },
        {
          path: 'safety-audit',
          name: 'qa_dashboard_safety_audit',
          meta,
          component: QaSafetyAuditPage,
        },
        {
          path: 'alert-hub',
          name: 'qa_dashboard_alert_hub',
          meta,
          component: QaAlertHubPage,
        },
        {
          path: 'agent-kpi',
          name: 'qa_dashboard_agent_kpi',
          meta: agentKpiMeta,
          component: QaAgentKpiPage,
        },
        {
          // The page behind an Agent KPI card. One component, one route per
          // topic: qaTopic tells it which figure it is explaining.
          path: 'agent-kpi/template-compliance',
          name: 'qa_dashboard_agent_kpi_template_compliance',
          meta: { ...agentKpiMeta, qaTopic: 'template_compliance' },
          component: QaMetricDetailPage,
        },
        {
          path: 'agent-kpi/first-reply',
          name: 'qa_dashboard_agent_kpi_first_reply',
          meta: { ...agentKpiMeta, qaTopic: 'first_reply' },
          component: QaMetricDetailPage,
        },
        {
          path: 'agent-kpi/confirmed-safety',
          name: 'qa_dashboard_agent_kpi_confirmed_safety',
          meta: { ...agentKpiMeta, qaTopic: 'confirmed_safety' },
          component: QaMetricDetailPage,
        },
        {
          path: 'customer-insight',
          name: 'qa_dashboard_customer_insight',
          meta,
          component: QaCustomerInsightPage,
        },
        {
          path: 'calibration',
          name: 'qa_dashboard_calibration',
          meta,
          component: QaCalibrationPage,
        },
        {
          path: 'trends',
          name: 'qa_dashboard_trends',
          meta,
          component: QaTrendsPage,
        },
        {
          path: 'appeals',
          name: 'qa_dashboard_appeals',
          meta: appealMeta,
          component: QaAppealsPage,
        },
      ],
    },
  ],
};

export default qaDashboardRoutes;
